import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M12 20c5.523 0 10-3.806 10-8.5S17.523 3 12 3C6.478 3 2 6.806 2 11.5c0 1.741.616 3.36 1.672 4.708L2 20l4.896-1.19A11.314 11.314 0 0 0 12 20Zm-5.56-6.47c.947 0 1.714-.755 1.714-1.686 0-.931-.767-1.686-1.714-1.686-.946 0-1.713.755-1.713 1.686 0 .931.767 1.686 1.713 1.686Zm7.42-1.686c0 .931-.766 1.686-1.713 1.686-.946 0-1.713-.755-1.713-1.686 0-.931.767-1.686 1.713-1.686.947 0 1.714.755 1.714 1.686Zm4.001 1.686c.946 0 1.713-.755 1.713-1.686 0-.931-.767-1.686-1.713-1.686-.946 0-1.713.755-1.713 1.686 0 .931.767 1.686 1.713 1.686Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }